import { Statistic, StatisticTreatment } from '../types'
import { AMOUNT_KEYWORDS } from '../constants/search'

export default function getStatisticTreatments(statistic: Statistic[] = [], language: string): StatisticTreatment[] {
  const normalizedStatistic = statistic.filter((f) => f.tagType === 'total').sort((a, b) => b.tagCount - a.tagCount)

  return [
    ...normalizedStatistic.map((s) => ({ label: s.tagName[language], variant: 'secondary' })).slice(0, AMOUNT_KEYWORDS),
    ...(normalizedStatistic.length > AMOUNT_KEYWORDS
      ? [{ label: `+${normalizedStatistic.length - AMOUNT_KEYWORDS}`, variant: 'secondary' }]
      : [])
  ]
}
